import React                               from 'react';
import ReactDOM                            from 'react-dom/client';
import App                                 from './App';
import reportWebVitals                     from './reportWebVitals';
import {StateProvider}                     from "./providers/stateProvider";
import StateReducerService, {initialState} from "./services/stateReducerService";

import './assets/scss/app.scss';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <StateProvider initialState={initialState} reducer={StateReducerService}>
            <App/>
        </StateProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
